module.exports = __webpack_public_path__ + "img/member_chevron.4163a20.png";